import { FC } from "react";
import { ZipCoverageMapMembershipType } from "@app/projects/zip-projects/maps/interfaces";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface ZipCoverageMapMembershipTypeFilterProps {
  readonly membershipType: ZipCoverageMapMembershipType;
  readonly setMembershipType: (value: ZipCoverageMapMembershipType) => void;
  readonly primaryMembershipAlias?: string;
  readonly secondaryMembershipAlias?: string;
}

export const ZipCoverageMapMembershipTypeFilter: FC<ZipCoverageMapMembershipTypeFilterProps> = ({
  membershipType,
  setMembershipType,
  primaryMembershipAlias,
  secondaryMembershipAlias,
}) => {
  const membershipTypeDisplay: Record<ZipCoverageMapMembershipType, string> = {
    [ZipCoverageMapMembershipType.Primary]: primaryMembershipAlias || "Primary Membership",
    [ZipCoverageMapMembershipType.Secondary]: secondaryMembershipAlias || "Secondary Membership",
  };

  return (
    <QESSelect
      allowEmpty={false}
      containerClassName="w-100"
      isValid={true}
      label="Membership Type"
      testId="zip-coverage-map__filter--membership-type"
      value={membershipType}
      onChange={(e) => setMembershipType(e.target.value as ZipCoverageMapMembershipType)}
    >
      {Object.values(ZipCoverageMapMembershipType).map((m) => (
        <option
          key={`zip-coverage-map__filter--membership-type-option--${m}`}
          data-testid={`zip-coverage-map__filter--membership-type-option--${m}`}
          value={m}
        >
          {membershipTypeDisplay[m]}
        </option>
      ))}
    </QESSelect>
  );
};

export default ZipCoverageMapMembershipTypeFilter;
